import { type SpreadsheetColumnId } from '~/_shared/types/spreadsheetData/spreadsheetColumn';

export type ChartsInfoData = Readonly<{
  label: string;
  data: ReadonlyArray<number>;
  backgroundColor: ReadonlyArray<string>;
  borderColor?: ReadonlyArray<string>;
  borderWidth?: number;
}>;

export type ChartsInfo = Readonly<{
  labels: string[];
  datasets: ChartsInfoData[];
}>;

export enum MaptiveChartType {
  DoughnutChart = 'DoughnutChart',
  HorizontalBarChart = 'HorizontalBarChart',
  PieChart = 'PieChart',
  PolarAreaChart = 'PolarAreaChart',
  RadarChart = 'RadarChart',
  VerticalBarChart = 'VerticalBarChart',
}

export enum MetricOptionKind {
  'LocationCount' = 'LocationCount',
  'Column' = 'Column',
}

export type MetricOption =
  | Readonly<{ kind: MetricOptionKind.LocationCount; name: string }>
  | (Readonly<{ kind: MetricOptionKind.Column; name: string }> & SpreadsheetColumnId);
